import React from "react";
import axios from "axios";
import socketIOClient from "socket.io-client";
import QRCode from "qrcode.react";
import { Grid, Hidden } from "@material-ui/core";
import Conf from "./Conf";

export default class Home extends React.Component {
  renew_url = Conf.backendURL;
  // renew_url = "https://cloud-3003.lib.cmu.ac.th/"
  state = {
    message: null,
    form: {
      name: "",
      code: "",
    },
  };
  componentDidMount() {
    axios.get(this.renew_url + "code").then((res) => {
      this.setState(
        {
          code: res.data.code,
          socket: res.data.socket,
        },
        () => this.bindSocket()
      );
      // console.log(res.data);
    });
  }
  oauthSignIn() {
    var callback = Conf.frontendURL + "auth";
    axios.post(Conf.signinURL + "login", { callback: callback }).then((res) => {
      if (res.data && res.data.login_url) window.location = res.data.login_url;
    });
  }
  // testSendPackage(){
  //   const { socket } = this.state
  //   var send = {
  //     "profile": {
  //       "cmuitaccount_name": "pratchaya.s",
  //       "cmuitaccount": "pratchaya.s@cmu.ac.th",
  //       "student_id": "",
  //       "prename_id": "OTH",
  //       "prename_TH": "",
  //       "prename_EN": "",
  //       "firstname_TH": "ปราชญ์",
  //       "firstname_EN": "PRATCH",
  //       "lastname_TH": "สงวนศักดิ์",
  //       "lastname_EN": "SANGUANSAK",
  //       "organization_code": "51",
  //       "organization_name_TH": "สำนักหอสมุด",
  //       "organization_name_EN": "CMU Library",
  //       "itaccounttype_id": "MISEmpAcc",
  //       "itaccounttype_TH": "บุคลากร",
  //       "itaccounttype_EN": "MIS Employee"
  //     },
  //     "payload": { "socket": socket }
  //   }
  //   axios.post(this.renew_url+"mobile/signin",send);
  // }
  bindSocket = () => {
    const endpoint = this.renew_url;
    const { socket } = this.state;
    const server = socketIOClient(endpoint);
    server.on("socket-" + socket, (messageNew) => {
      var response = JSON.parse(messageNew);
      if (response && response.error) alert(response.error);
      else {
        document.getElementById("code").value = response.patron_code;
        document.getElementById("name").value =
          response.first_name + " " + response.last_name;
        document.getElementById("patform").submit();
      }
    });
  };
  render() {
    const { code, /* socket, */ form } = this.state;
    const styles = {
      GridLeft: {
        background: "#fff",
        minHeight: "87vh",
      },
      GridRight: {
        background:
          "linear-gradient(180deg, rgba(217,163,248,1) 0%, rgba(195,158,251,1) 50%, rgba(167,148,254,1) 100%)",
        minHeight: "87vh",
      },
      qrContainer: {
        WebkitBoxShadow: "2px 2px 7px 0px rgba(0,0,0,0.3)",
        MozBoxShadow: "2px 2px 7px 0px rgba(0,0,0,0.3)",
        boxShadow: "5px 5px 10px 0px rgba(0,0,0,0.3)",
        width: "270px",
        height: "260px",
        paddingTop: "10px",
        margin: "auto auto auto",
        background: "#fff",
      },
    };
    return (
      <div>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6} style={styles.GridLeft}>
            <Hidden smDown>
              <h1
                style={{
                  textAlign: "right",
                  fontSize: "5em",
                  lineHeight: ".8em",
                  marginRight: "15px",
                  color: "#8244D2",
                  textShadow: "4px 4px #D8DBFA",
                }}
              >
                Renew
              </h1>
            </Hidden>
            <Hidden mdUp>
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "3em",
                  lineHeight: ".8em",
                  marginBottom: "70px",
                }}
              >
                Renew Online
              </h1>
            </Hidden>
            <div style={{ textAlign: "center" }}>
              <h2 style={{ color: "#8465BF" }}>Login with CMU Account</h2>
              <a href="#!" onClick={() => this.oauthSignIn()}>
                <img
                  src="/renew/img/renew-06-05.png"
                  alt=""
                  style={{ maxWidth: "100%" }}
                />
              </a>
              <h2
                style={{
                  color: "#8465BF",
                  lineHeight: ".5em",
                  marginTop: "50px",
                }}
              >
                สำหรับสมาชิกสมทบ
              </h2>
              <h3 style={{ color: "#8465BF", lineHeight: ".5em" }}>
                (Outsiders member)
              </h3>
              <a href="https://search.lib.cmu.ac.th/patroninfo">
                <img
                  src="/renew/img/renew-06-06.png"
                  alt=""
                  style={{ maxWidth: "100%" }}
                />
              </a>
            </div>
          </Grid>
          <Grid item xs={12} md={6} style={styles.GridRight}>
            <Hidden smDown>
              <h1
                style={{
                  fontSize: "5em",
                  lineHeight: ".8em",
                  marginLeft: "15px",
                  color: "#fff",
                  textShadow: "4px 4px #AF95D9",
                }}
              >
                Online
              </h1>
            </Hidden>
            <h2
              style={{ color: "#fff", textAlign: "center", marginTop: "50px" }}
            >
              Scan with CMU Mobile
            </h2>

            <div style={{ textAlign: "center" }}>
              <div
                /* style={{width:'270px',height:'260px',paddingTop:'10px',margin:'auto auto auto',background:'#fff'}} */ style={
                  styles.qrContainer
                }
              >
                {code && (
                  <QRCode
                    value={code}
                    renderAs="svg"
                    size={250}
                    imageSettings={{
                      src: "/renew/img/logo_cmu.png",
                      height: 30,
                      width: 30,
                    }}
                  />
                )}
              </div>
              <div
                style={{
                  color: "#1D0E49",
                  fontWeight: "bold",
                  margin: "50px auto auto 50px",
                  textAlign: "left",
                }}
              >
                Download APP
                <div>
                  <a
                    href="https://play.google.com/store/apps/details?id=th.ac.cmu.mobile.portal"
                    rel="noopener noreferrer"
                    target="_blank"
                    title="Google Play"
                  >
                    <img
                      src="/renew/img/google-play-badge.png"
                      style={{ width: "150px" }}
                      alt=""
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/th/app/cmu-mobile/id946339651"
                    rel="noopener noreferrer"
                    target="_blank"
                    title="App Store"
                  >
                    <img
                      src="/renew/img/ios-badge.png"
                      style={{ width: "150px" }}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid
            item
            xs={8}
            md={6}
            style={{
              minHeight: "13vh",
              background: "#7E45DA",
              color: "#fff",
              padding: "20px 30px",
              paddingBottom: "0px",
            }}
          >
            <div style={{ fontWeight: "400" }}>วิธีการใช้งาน มี 2 วิธี</div>
            <div style={{ paddingLeft: "15px" }}>
              1. Login ผ่าน CMUOAuth เข้าสู่ระบบสมาชิก
              จากนั้นทำการยืมหนังสือต่อได้ตามต้องการ
              <br />
              2. Scan QR Code จาก Application CMU Mobile
            </div>
            <div
              style={{
                paddingLeft: "32px",
                color: "#fff",
                fontSize: ".8em",
                marginTop: "3px",
              }}
            >
              จากนั้นทำการยืมหนังสือต่อได้ตามต้องการ
            </div>
          </Grid>
          <Hidden mdUp>
            <Grid
              item
              xs={4}
              md={6}
              style={{
                minHeight: "13vh",
                background: "#7E45DA",
                color: "#fff",
                padding: "20px 30px",
                paddingBottom: "0px",
              }}
            >
              <div style={{ fontWeight: "400" }}>เงื่อนไขการใช้บริการ</div>
              <div style={{ paddingLeft: "15px" }}>
                - ไม่เกินกำหนดส่ง
                <br />
                - ไม่มีคนอื่นจอง
                <br />- ยืมต่อออนไลน์ได้ 3 ครั้ง
              </div>
            </Grid>
          </Hidden>
          <Hidden smDown>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                minHeight: "13vh",
                background: "#5910C1",
                color: "#fff",
                padding: "20px 30px",
                paddingRight: "0px",
                paddingBottom: "0px",
              }}
            >
              <div style={{ fontWeight: "400" }}>เงื่อนไขการใช้บริการ</div>
              <div style={{ paddingLeft: "15px" }}>
                - ไม่เกินกำหนดส่ง
                <br />
                - ไม่มีคนอื่นจอง
                <br />- ยืมต่อออนไลน์ได้ 3 ครั้ง
              </div>
              <img
                src="/renew/img/renew-06-07.png"
                style={{ float: "right", marginTop: "-25vh", height: "25vh" }}
                alt=""
              />
            </Grid>
          </Hidden>
        </Grid>
        {/* <div>{code || ''}</div>
        <div>{socket || ''}</div>
        <button onClick={()=>this.testSendPackage()}>Test</button> */}
        {/* <div style={styles.qrContainer}>
          <img src="/renew/img/logo_cmul.png" alt="" style={{width:'100%',marginBottom:'0px'}} />
          <div>
            <h1 style={{marginBottom:'30px'}}>Renew Online</h1>
          </div>
          <div>
            <div style={{width:'200px',border:'1px solid #ccc',height:'50px',margin:'20px auto',borderRadius:'3px'}}>
              <a href="#!" onClick={()=>this.oauthSignIn()}>
                <img src="/renew/img/logo-CMUOAuth-large-inverse2.png" style={{width:'150px'}} alt="" />
              </a>
            </div>
          </div>



          <div>
            <h1 style={{color:'#641694',lineHeight:'.5em'}}>Signin</h1>
            <div style={{marginBottom:'20px',fontWeight:'bold'}}>CMU Mobile</div>
            <a href="https://play.google.com/store/apps/details?id=th.ac.cmu.mobile.portal" rel="noopener noreferrer" target="_blank" title="Google Play">
              <img src="/renew/img/google-play-badge.png" style={{width:'150px'}} alt="" />
            </a>
            <a href="https://apps.apple.com/th/app/cmu-mobile/id946339651" rel="noopener noreferrer" target="_blank" title="App Store">
              <img src="/renew/img/ios-badge.png" style={{width:'150px'}} alt="" />
            </a>
          </div>
        </div> */}
        <form
          action="https://search.lib.cmu.ac.th/patroninfo"
          name="patform"
          method="POST"
          target="_parent"
          id="patform"
        >
          <div>
            <input name="name" id="name" type="hidden" value="" readOnly />
          </div>
          <div>
            <input name="code" id="code" type="hidden" value="" readOnly />
          </div>
          <div>
            <input type="hidden" name="pat_submit" value="xxx" />
          </div>
        </form>
      </div>
    );
  }
}
